export const categories = [
  {
    slug: 'hetong-qicao',
    name: '合同起草',
    description: '在线协作起草各类合同文件，支持多人实时编辑、版本追踪与批注审核，让合同拟定更高效准确。',
    icon: 'ri-file-text-line',
    articleCount: 12,
  },
  {
    slug: 'fangan-cehua',
    name: '方案策划',
    description: '团队在线共同撰写商业方案、项目策划书，支持结构化模板与协同编辑，快速产出高质量方案。',
    icon: 'ri-lightbulb-line',
    articleCount: 10,
  },
  {
    slug: 'chuangyi-neirong',
    name: '创意内容',
    description: '针对创意写作、内容营销场景，提供灵活的在线协作环境，让灵感碰撞出更好的作品。',
    icon: 'ri-quill-pen-line',
    articleCount: 8,
  },
  {
    slug: 'tuandui-xiezuo',
    name: '团队协作',
    description: '一站式团队文档协作解决方案，实时同步、权限管理、评论讨论，提升团队整体写作效率。',
    icon: 'ri-team-line',
    articleCount: 15,
  },
  {
    slug: 'wendang-moban',
    name: '文档模板',
    description: '丰富的专业文档模板库，涵盖合同、方案、报告等多种类型，快速启动您的文稿创作。',
    icon: 'ri-file-copy-line',
    articleCount: 20,
  },
];

export const categoryMap: Record<string, typeof categories[0]> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});